import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fae7a1e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-skeleton justify-between" }
const _hoisted_2 = { class: "cart-skeleton-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-secondary alert-secondary-sk",
  style: {"min-height":"80px"}
}, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "my-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Choose your plan", -1 /* HOISTED */))
const _hoisted_6 = {
  class: "row",
  style: {"padding-top":"20px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card pla-card" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-body img",
    style: {"min-height":"150px"}
  })
], -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
            return _createElementVNode("div", {
              class: "col-12 col-md mb-3 mb-md-0",
              key: index
            }, _hoisted_8)
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ])
    ])
  ]))
}